var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("bottom-toolbar"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-content" },
        [
          _c("div", { staticClass: "layoutTop" }),
          _vm._v(" "),
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "10", "offset-md": "1" } },
                    [
                      _c("back-button"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "panel21 panel-default" },
                        [
                          _c("div", { staticClass: "panel-heading" }, [
                            _c(
                              "h4",
                              {
                                staticClass: "content-block labelAccordionForm",
                              },
                              [
                                _c("f7-icon", {
                                  staticClass: "formIcon",
                                  attrs: { fa: "address-book" },
                                }),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("contacts.cntct_grp_dtls")) +
                                    "\n                "
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputLabel: _vm.$t("common.nme"),
                                      inputValue: _vm.contactGroupLabel,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c("b-col", { staticClass: "form-group" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t("contacts.cntcts_in_ths_grp")
                                    ) +
                                    "\n                "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                1
                                  ? _c(
                                      "ul",
                                      {
                                        staticClass: "list-group",
                                        attrs: { disabled: "" },
                                      },
                                      _vm._l(
                                        this.contactsArray,
                                        function (value) {
                                          return _c(
                                            "li",
                                            {
                                              key: value.id,
                                              staticClass: "list-group-item",
                                            },
                                            [_vm._v(_vm._s(value.label))]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "justify-content-start" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "height-button",
                      attrs: { md: "3", "offset-md": "5" },
                    },
                    [
                      _c(
                        "f7-button",
                        {
                          staticClass: "button-action milkyBlockBlack",
                          attrs: { href: "/account/editContactGroup/" },
                        },
                        [
                          _c("f7-icon", {
                            staticClass: "icon-float-sub-button",
                            attrs: { icon: "icon-edit" },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("common.edit_label"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "height-button", attrs: { md: "3" } },
                    [
                      _c(
                        "f7-button",
                        {
                          staticClass: "button-action milkyBlockBlack",
                          on: { click: _vm.removeContactGroup },
                        },
                        [
                          _c("f7-icon", {
                            staticClass: "button-delete",
                            attrs: { f7: "close_round" },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("common.rm_label"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "toolbarPageBottomBlank" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }